// TODO: Move all the static cohorts defined in landing pages
// e.g. src/Deer/pages/Company/Reviews/CompanyReviewsManage.tsx:13
// to this file and import them in the respective files

export const STATIC_COHORTS = {
  company: {
    id: -1,
    name: 'My Company',
    type: 'ALL_EMPLOYEE',
  },
  team: {
    allReports: {
      id: -3,
      name: 'My Team',
      type: 'MY_ORGANIZATION',
    },
    directReports: {
      id: -2,
      name: 'My Team',
      type: 'MY_TEAM',
    },
  },
};
